import { Datagrid, List, SimpleList, TextField } from "react-admin";
import { useMediaQuery } from "@mui/material";
import LocateStudentInStudyGroupDialog from "./LocateStudentInStudyGroupDialog";
import { settings } from "app";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";

const UnallocatedStudentsTable = ({ studentFilters }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Неразпределени студенти"
      filter={studentFilters}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Име", value: <TextField source="firstName" /> }]} />
              <MobileListRow fields={[{ label: "Фамилия", value: <TextField source="lastName" /> }]} />
            </div>
          )}
          secondaryText={() => (
            <div>
              <MobileListRow fields={[{ label: "Презиме", value: <TextField source="secondName" /> }]} />
              <MobileListRow fields={[{ label: "Факултетен номер", value: <TextField source="facultyNumber" /> }]} />
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={
            <SecuredComponent permission={permissions.canMoveStudentsBetweenStudyGroups}>
              <LocateStudentInStudyGroupDialog />
            </SecuredComponent>
          }
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="secondName"
            label="Презиме"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <TextField
            source="facultyNumber"
            label="Факултетен номер"
            sortable={false}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default UnallocatedStudentsTable;
